import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from 'src/app/constants/app.constants';
import { ReportsService } from 'src/app/services/reports.service';
import { UserService } from 'src/app/services/user.service';
import { saveAs } from 'file-saver';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';
import { HttpErrorResponse } from '@angular/common/http';
import { ApproveDialogComponent } from '../../approve-dialog/approve-dialog.component';
@Component({
    selector: 'app-mar-report',
    templateUrl: './mar-report.component.html',
    styleUrls: ['./mar-report.component.scss'],
    standalone: false
})
export class MarReportComponent implements OnInit {
  marForm: UntypedFormGroup;
  userData:UserData;
  user:UsersDataResponse;
  maxDate:Date=new Date();
  constructor(private route: ActivatedRoute,private userservice:UserService,
    private reportsService: ReportsService, private fb: UntypedFormBuilder,private router:Router,private dialog:MatDialog) { }
  

  ngOnInit(): void {
    this.userservice.getCurrentUser().subscribe(data=>{
      this.user=data;
      this.userData=data.userData;
  
      if(this.userData.roleId<4){
      this.createFormDC();
      }else{
        this.createFormStore();
      }
    })
  }

  createFormDC() {
    this.marForm = this.fb.group({
    //  storeNumber: ['', Validators.required],
     // dcNumber:['',Validators.required],
      fromDate:['',Validators.required],
      toDate:['',Validators.required],
      dcNumber:[null,Validators.required]
     
   
      
    });

  }

  createFormStore() {
    this.marForm = this.fb.group({
    //  storeNumber: ['', Validators.required],
     // dcNumber:['',Validators.required],
      fromDate:['',Validators.required],
      toDate:['',Validators.required],
      dcNumber:[null,]
     
   
      
    });

  }

  generateMarReport(){
    let fromDate = JSON.stringify(this.marForm.controls.fromDate.value).slice(1, 11);
    let toDate = JSON.stringify(this.marForm.controls.toDate.value).slice(1, 11);
    this.reportsService.getMarReport(this.marForm.controls.dcNumber.value,fromDate,toDate).subscribe(data=>{
      console.log(data.headers.get('Content-Disposition'));
      let contentDispositionHeader= data.headers.get('Content-Disposition')
      let fileName = 'Report.csv'; // Default filename
            if (contentDispositionHeader) {
                fileName = contentDispositionHeader.split(';')[1].trim().split('=')[1].replace(/"/g, '');
            }
      saveAs(new Blob([data.body], { type: AppConstants.MIME_TYPES['xlsx'] }), fileName);
    },(error:HttpErrorResponse)=>{
     
      if(error && error.status===404){
      let dialogData= {
        title: this.userData.language==="EN"?'No Records Found':"Aucune transaction trouvée",
        message: this.userData.language==="EN"?"No records to display.":"Aucune transaction à afficher",
       
      }
      this.dialog.open(ApproveDialogComponent,{
        data:dialogData,panelClass: 'my-class'
      });
    }
  })
  }

}
function utf8_decode(body: any): BlobPart {
  throw new Error('Function not implemented.');
}

